import api from "@/api";

/**
 * STATE
 */
const getDefaultState = () => ({
    participants: [],
});

let state = getDefaultState();

/**
 * GETTERS
 */
const getters = {
    participants(state) {
        return state.participants ?? [];
    },
};

/**
 * ACTIONS
 */
const actions = {
    async getParticipants(
        { commit, state },
        { payload: { surveyId, surveryPeriodStartDate, users, offset } } = { payload: {} },
    ) {
        const { data } = await api.get(`/api/surveys/${surveyId}/participants`, {
            params: {
                surveryPeriodStartDate,
                users,
                offset,
            },
        });

        commit("setParticipants", offset > 0 ? state.participants.concat(data) : data);
    },
};

/**
 * MUTATIONS
 */
const mutations = {
    setParticipants(state, participants = []) {
        state.participants = participants;
    },
    resetModuleState() {
        state = getDefaultState();
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
